module.exports = __webpack_public_path__ + "img/rectangle2.5e088522.png";